<template>
  <div class="filters">
    <div
      class="filters__filter"
      v-if="sizeFilter"
    >
      <size-filter
        :name="sizeFilter.id"
        @apply="applyCategoryFilter({ filterData: [$event] })"
        @clear="clearAppliedFilter"
        :placeholder="sizeFilter.name"
        :options="sizeFilter.values"
        :value="sizeFilterValue"
      />
    </div>

    <div
      class="filters__filter"
      v-if="colorFilter"
    >
      <color-filter
        :name="colorFilter.id"
        @apply="applyCategoryFilter({ filterData: [$event] })"
        @clear="clearAppliedFilter"
        :placeholder="colorFilter.name"
        :options="colorFilter.values"
        :value="colorFilterValue"
      />
    </div>

    <div
      class="filters__filter"
      v-if="priceFilter"
    >
      <price-filter
        :name="priceFilter.id"
        @apply="applyCategoryFilter({ filterData: [$event] })"
        @clear="clearAppliedFilter"
        :placeholder="priceFilter.name"
        :options="priceFilter.values"
        :value="priceFilterValue"
      />
    </div>

    <ui-button
      class="filters__all-filters"
      secondary
      :text="filtersButtonTitle"
      :count="appliedFiltersCount"
      :icon="$options.icons.IconFilter.id"
      :value="priceFilterValue"
      @click="showFiltersPanel"
    />

    <button
      v-if="appliedFiltersCount"
      class="filters__clear"
      @click="clearAllAppliedFilters"
    >
      Сбросить
    </button>

    <category-sort
      class="filters__sort"
      :value="sort"
      @sort-change="applyCategoryFilter({ sort: $event })"
    />

    <filters-drawer
      :is-opened="isShownFiltersPanel"
      @close="isShownFiltersPanel = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import SizeFilter from '@/components/size-filter/size-filter.vue';
import ColorFilter from '@/components/color-filter/color-filter.vue';
import PriceFilter from '@/components/price-filter/price-filter.vue';
import CategorySort from '@/components/category-sort/category-sort.vue';
import FiltersDrawer from '@/components/filters/filters-drawer.vue'

import IconFilter from '@icons/filter.svg';

export default {
  name: 'filters',

  components: {
    SizeFilter,
    ColorFilter,
    PriceFilter,
    CategorySort,
    FiltersDrawer,
  },

  inject: ['adaptive'],

  icons: {
    IconFilter
  },

  data() {
    return {
      isShownFiltersPanel: false,
    }
  },

  computed: {
    ...mapGetters('category', [
      'sizeFilter',
      'colorFilter',
      'priceFilter',
      'sizeFilterValue',
      'colorFilterValue',
      'priceFilterValue',
      'appliedFiltersCount',]),
    ...mapState('category', [
      'sort',
      'appliedFiltersState',
    ]),

    filtersButtonTitle() {
      return this.adaptive.isMobile ? 'Фильтры и сортировка' : 'Фильтры';
    },
  },

  methods: {
    ...mapActions('category', [
      'applyCategoryFilter',
      'clearAppliedFilter',
      'clearAllAppliedFilters',
    ]),

    showFiltersPanel() {
      this.isShownFiltersPanel = true;
    }
  }
}
</script>

<style lang="scss">
  .filters {
    display: flex;
    align-items: center;

    &__sort {
      display: none;

      @include breakpoint("tablet") {
        display: block;
        flex: 1 1 50%;

        &.ui-select {
          width: 200px;
        }
      }
      @include breakpoint("desktop") {
        flex: 0 0 auto;
        margin-left: auto;
      }
    }

    &__filter {
      margin-right: 8px;
      display: none;

      @include breakpoint("desktop") {
        display: block;
      }
    }

    &__clear {
      cursor: pointer;
      color: $gray_l;
      font-weight: 600;
      margin-left: 17px;
      background: none;
      display: none;

      @include breakpoint("desktop") {
        display: block;
      }
    }

    &__all-filters.ui-button {
      flex: 1;

      @include breakpoint("tablet") {
        flex: 1 1 50%;
        margin-right: 16px;
      }

      @include breakpoint("desktop") {
        flex: 0 0 auto;
      }
    }
  }
</style>
